import { render, staticRenderFns } from "./PowerBiReportsTable.vue?vue&type=template&id=1ef13ab8&"
import script from "./PowerBiReportsTable.vue?vue&type=script&lang=js&"
export * from "./PowerBiReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports